module.exports = __webpack_public_path__ + "img/address-icon.871fe23e.png";